module.exports = __webpack_public_path__ + "static/media/ECONNECT.4c262cdb.webp";